export default __webpack_public_path__ + "static/media/learn-from-prototype-arrow-mobile.065fa375.svg";